<template>
  <div class="loader">
    <div class="ball"></div>
    <div class="ball"></div>
    <div class="ball"></div>
    <div class="shadow"></div>
    <div class="shadow"></div>
    <div class="shadow"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" src="@/assets/scss/loader.scss"></style>